import { IonCol, IonItem, IonRow, IonSelect, IonSelectOption } from "@ionic/react"
import { useEffect, useState } from "react"
import AE2Input from "../../elements/AE2Input"

interface Props{
    setParentForm:Function
    formErrors:[errors:any,setErrors:Function]
}

const startingForm = {
totalGrossFloorArea : "",
totalGrossFloorArea_units : "",
totalGrossFloorArea_date : "",
numberOfBedrooms : "",
numberOfBedrooms_date : "",
numberOfPeople : "",
numberOfPeople_date : "",

}
const startErrors = {
totalGrossFloorArea : "GFA cannot be empty",
totalGrossFloorArea_units : "Units cannot be empty",
totalGrossFloorArea_date : "Date cannot be empty",
numberOfBedrooms : "",
numberOfBedrooms_date : "",
numberOfPeople : "",
numberOfPeople_date : "",
}

const SingleFamilyHome: React.FC<Props> = ({setParentForm,formErrors}) => {

    const [form, setForm] = useState(startingForm)
    const [errors, setErrors] = formErrors
    const handleFormChange = (value:any,name:string) => {
        validate(name,value)
        setForm((prevState) => {
            return {
                ...prevState,
                [name]:value
            }
        } )
        setParentForm({...form, [name]:value},'form')

    }

    const handleError = (name:string,value:any) => {
        setErrors((prevState:any) => {
            return {
                ...prevState,
                [name]:value
            }
        } )

    }

    const getCurrentDate = () => {
        return new Date().getTime();
      };


    useEffect(()=>{
        setErrors((prevState:any) => {
            return {
                ...prevState,
                ...startErrors
            }
        } )
    }, [setErrors])

    const validate = (name:string, value:any) => {
        switch(name){
            case ('totalGrossFloorArea'):
                if (value === ''){
                    handleError('totalGrossFloorArea','Gross Floor Are Cannot be Empty')
                }
                else if (value < 0){
                    handleError('totalGrossFloorArea','GFA must be a positive number')
                }
                else {
                    handleError('totalGrossFloorArea','')
                }
                break;
            case ('totalGrossFloorArea_units'):
                if (value === ''){
                    handleError('totalGrossFloorArea_units','Select gfa units')
                }
                else {
                    handleError('totalGrossFloorArea_units','')
                }
                break;
            case ('totalGrossFloorArea_date'):
                if (value === ''){
                    handleError('totalGrossFloorArea_date','Date cannot be empty')
                }
                else if (new Date(value).getTime() > getCurrentDate()){
                    handleError('totalGrossFloorArea_date','Invalid Date')
                }
                else {
                    handleError('totalGrossFloorArea_date','')
                }
                break;
            case('numberOfPeople'):
                if(value !==''){
                    form.numberOfPeople_date === '' ? handleError('numberOfPeople_date','Date cannot be empty') : handleError('numberOfPeople_date','')
                    value < 0 ? handleError('numberOfPeople','Must be a Positive number') : handleError('numberOfPeople','')
                }
                else{
                    handleError('numberOfPeople','')
                    handleError('numberOfPeople_date','')
                }
                break;
            case('numberOfPeople_date'):
                if(value !==''){
                    form.numberOfPeople === '' ? handleError('numberOfPeople','Field cannot be empty') : handleError('numberOfPeople','')
                    new Date(value).getTime() > getCurrentDate() ? handleError('numberOfPeople_date','Invalid Date') : handleError('numberOfPeople_date','')
                }
                else{
                    handleError('numberOfPeople','')
                    handleError('numberOfPeople_date','')
                }
                break;
            case('numberOfBedrooms'):
                if(value !==''){
                    form.numberOfBedrooms_date === '' ? handleError('numberOfBedrooms_date','Date cannot be empty') : handleError('numberOfBedrooms_date','')
                    value < 0 ? handleError('numberOfBedrooms','Must be a Positive number') : handleError('numberOfBedrooms','')
                }
                else{
                    handleError('numberOfBedrooms','')
                    handleError('numberOfBedrooms_date','')
                }
                break;
            case('numberOfBedrooms_date'):
                if(value !==''){
                    form.numberOfBedrooms === '' ? handleError('numberOfBedrooms','Field cannot be empty') : handleError('numberOfBedrooms','')
                    new Date(value).getTime() > getCurrentDate() ? handleError('numberOfBedrooms_date','Invalid Date') : handleError('numberOfBedrooms_date','')
                }
                else{
                    handleError('numberOfBedrooms','')
                    handleError('numberOfBedrooms_date','')
                }
                break;

            default:
                break;
        }
    }

    return (
        <div className="text-dark-blue">
            <h1>Single Family Home Form</h1>
            <IonRow>
                <IonCol sizeLg="4">
                    <IonItem lines="none">
                        <AE2Input label="Total Gross Floor Area" type="number" errorText={errors.totalGrossFloorArea}  value={form.totalGrossFloorArea} placeholder='GFA' onIonInput={e => (handleFormChange(e.detail.value!,'totalGrossFloorArea'))}></AE2Input>
                    </IonItem>
                </IonCol>
                <IonCol sizeLg="4">
                    <IonItem lines="none">
                    <div style={{width:'100%'}}>
                        <IonSelect label="Units" className={errors.totalGrossFloorArea_units === '' ? "valid":'invalid'} value={form.totalGrossFloorArea_units} interface='popover' placeholder='Units' onIonChange={e => (handleFormChange(e.detail.value!,'totalGrossFloorArea_units'))}>
                            <IonSelectOption value={'Square Feet'}>Square Feet</IonSelectOption>
                            <IonSelectOption value={'Square Meters'}>Square Meters</IonSelectOption>
                        </IonSelect>
                        <div className="error-detail">{errors.totalGrossFloorArea_units}</div>
                        </div>
                    </IonItem>
                </IonCol>
                <IonCol sizeLg="4">
                    <IonItem lines="none">
                        <AE2Input label="Current as of:" type="date" errorText={errors.totalGrossFloorArea_date} value={form.totalGrossFloorArea_date} placeholder='Date' onIonInput={e => (handleFormChange(e.detail.value!,'totalGrossFloorArea_date'))}></AE2Input>
                    </IonItem>
                </IonCol>
            </IonRow>
            <IonRow>
                <IonCol sizeLg="4">
                    <IonItem lines="none">
                        <AE2Input label="Number of Bedrooms" type="number" errorText={errors.numberOfBedrooms}  value={form.numberOfBedrooms} placeholder='# Bedrooms' onIonInput={e => (handleFormChange(e.detail.value!,'numberOfBedrooms'))}></AE2Input>
                    </IonItem>
                </IonCol>
                <IonCol sizeLg="4">
                    <IonItem lines="none">
                        <AE2Input label="Current as of:" type="date" errorText={errors.numberOfBedrooms_date}  value={form.numberOfBedrooms_date} placeholder='Date' onIonInput={e => (handleFormChange(e.detail.value!,'numberOfBedrooms_date'))}></AE2Input>
                    </IonItem>
                </IonCol>
            </IonRow>
            <IonRow>
                <IonCol sizeLg="4">
                    <IonItem lines="none">
                        <AE2Input label="Number of People" type="number" errorText={errors.numberOfPeople}  value={form.numberOfPeople} placeholder='# People' onIonInput={e => (handleFormChange(e.detail.value!,'numberOfPeople'))}></AE2Input>
                    </IonItem>
                </IonCol>
                <IonCol sizeLg="4">
                    <IonItem lines="none">
                        <AE2Input label="Current as of:" type="date" errorText={errors.numberOfPeople_date}  value={form.numberOfPeople_date} placeholder='Date' onIonInput={e => (handleFormChange(e.detail.value!,'numberOfPeople_date'))}></AE2Input>
                    </IonItem>
                </IonCol>
            </IonRow>
        </div>
    )
}

export default SingleFamilyHome